import { Marker, Tooltip } from 'react-leaflet';
import { divIcon } from 'leaflet';
import { EmployeeCluster } from '../types/employee';
import type { HQConfig } from '../utils/geoUtils';

interface ClusteredEmployeeMarkerProps {
  cluster: EmployeeCluster;
  onClusterClick: (cluster: EmployeeCluster) => void;
  hq?: HQConfig | null;
}

// Building2 lucide icon — office building with floors and entrance
const HQ_ICON_SVG = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>`;

const ClusteredEmployeeMarker = ({ cluster, onClusterClick, hq }: ClusteredEmployeeMarkerProps) => {
  const hqInCluster = hq != null &&
    hq.latitude  >= cluster.bbox.minLat && hq.latitude  <= cluster.bbox.maxLat &&
    hq.longitude >= cluster.bbox.minLng && hq.longitude <= cluster.bbox.maxLng;

  const icon = hqInCluster
    ? divIcon({
        className: 'leaflet-div-icon',
        html: `<div class="cluster-marker-wrap cluster-marker-wrap--hq"><div class="map-marker cluster-marker cluster-marker--hq">${HQ_ICON_SVG}</div><div class="cluster-count">${cluster.size()}</div></div>`,
        iconSize: [40, 40],
        iconAnchor: [20, 20],
      })
    : divIcon({
        className: 'leaflet-div-icon',
        html: `<div class="cluster-marker-wrap"><div class="map-marker cluster-marker"><div class="cluster-bolt"></div></div><div class="cluster-count">${cluster.size()}</div></div>`,
        iconSize: [48, 48],
        iconAnchor: [24, 24],
      });

  return (
    <Marker
      position={[cluster.center.latitude, cluster.center.longitude]}
      icon={icon}
      eventHandlers={{
        click: () => onClusterClick(cluster),
      }}
    >
      <Tooltip direction="top" offset={[0, -5]}>
        <div className="text-center">
          <div className="font-medium">{cluster.size()} Team Members</div>
          {hqInCluster && <div className="text-xs" style={{ color: '#38bdf8' }}>{hq!.name} nearby</div>}
          <div className="text-xs text-gray-600">Click to zoom in</div>
        </div>
      </Tooltip>
    </Marker>
  );
};

export default ClusteredEmployeeMarker;
